import React from 'react';
import { Table } from 'antd';
import groupBy from 'lodash/groupBy';
import values from 'lodash/values';
import sortBy from 'lodash/sortBy';
import sumBy from 'lodash/sumBy';
import reverse from 'lodash/reverse';
import { formatNumber } from '../../utils/format';
import StarIcon from './starIcon';


const FeedbackCarsTable = ({ data, pageSize }) => {
    var byDriver = values(groupBy(data, 'carId')).map(feedbacks => ({
        carId: feedbacks[0].carId,
        carName: `${feedbacks[0].carName} (${feedbacks[0].carNum})`,
        averageRating: sumBy(feedbacks, 'rating') / feedbacks.length,
        countRating: feedbacks.length
    }))
    byDriver = reverse(sortBy(byDriver, 'averageRating'));
    return <Table
        pagination={{ position: "bottom", pageSize: pageSize || 6 }}
        dataSource={byDriver}
        rowKey="carId"
    >
        <Table.Column 
            title="Машина"
            dataIndex="carName"
        />
        <Table.Column 
            sorter={(a, b) => parseFloat(a.averageRating) - parseFloat(b.averageRating)}
            title="Средняя оценка"
            dataIndex="averageRating"
            render={v => <div>
                <StarIcon rating={v} style={{marginRight: 8}} />
                {formatNumber(v, 1)}
            </div>}
        />
        <Table.Column 
            sorter={(a, b) => parseInt(a.countRating) - parseInt(b.countRating)}
            title="Количество оценок"
            dataIndex="countRating"
        />
    </Table>
}

export default FeedbackCarsTable;